<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"COMPANY.erase-company" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"COMPANY.proceed-adverticing" | translate}}</p>
  <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"COMPANY.text-warning" | translate}}</small>


  <div class="btn-proceed alt-flex-end">
    <button  class="btn-cancel alt-color-bran1 pointer alt-size-14 alt-inter-medium  " type="button" [mat-dialog-close]="false" >{{"USERS.go-back" | translate | uppercase }}</button>
    <button  class="btn-agree alt-color-bran1 pointer alt-size-14 alt-inter-medium  "  type="button" [mat-dialog-close]="true">{{"COMPANY.erase-agreed" | translate | uppercase
      }}</button>
  </div></div>

